import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import PageHeader from "../components/PageHeader";
import {TurnstileButton} from "../components/Button";
import {FiPlus} from "react-icons/fi";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {EmptyState} from "../components/Table";
import ConfigModal from "./ConfigModal";
import ConfigTable from "./ConfigTable";
import Toast from "cogo-toast";
import {apiCreateConfig, apiGetConfig, apiGetConfigKeys, apiUpdateConfig} from "./Actions";

const Config = ({}) => {
    let [data, setData] = useState(null);
    let [configKeys, setConfigKeys] = useState([]);
    let [loading, setLoading] = useState(false);
    let [editData, setEditData] = useState(null);
    let [modalVisible, setModalVisible] = useState(false);
    let [saving, setSaving] = useState(false);
    let user = useSelector((state) => state.user);

    const loadData = () => {
        if (!user.activeAreal) return;
        setLoading(true);
        apiGetConfig(user.activeAreal.id, (result) => {
            setData(result ?? []);
            setLoading(false);
        }, () => {
            setLoading(false);
            Toast.error("Nepodařilo se načíst konfiguraci.");
        });
    };

    useEffect(() => {
        loadData();
        if (user.activeAreal) {
            apiGetConfigKeys(user.activeAreal.id, (result) => setConfigKeys(result ?? []), () => {});
        }
    }, [user.activeAreal]);

    const saveConfig = (values) => {
        if (!user.activeAreal) return;
        setSaving(true);
        const onOk = () => {
            setSaving(false);
            setModalVisible(false);
            Toast.success("Uloženo.");
            loadData();
        };
        const onErr = () => {
            setSaving(false);
            Toast.error("Nepodařilo se uložit.");
        };
        if (editData) {
            apiUpdateConfig(user.activeAreal.id, editData.id,
                {value: values.value, description: values.description}, onOk, onErr);
        } else {
            apiCreateConfig(user.activeAreal.id,
                {configKey: values.configKey, value: values.value, description: values.description}, onOk, onErr);
        }
    };

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám konfiguraci..."}/>;
        if (!loading && data && data.length > 0) return <ConfigTable data={data} setData={setData} configKeys={configKeys} setEditData={(row) => {
            setEditData(row);
            setModalVisible(true);
        }}/>;
        return <EmptyState/>;
    };

    return (
        <div>
            {user.activeAreal && (
                <div>
                    <PageHeader crumbs={[{label: "Konfigurace"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton onClick={() => {
                                setEditData(null);
                                setModalVisible(true);
                            }} text="PŘIDAT" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {_renderBody()}
                    {modalVisible && <ConfigModal initData={editData} configKeys={configKeys}
                                                  onClose={() => setModalVisible(false)} visible={modalVisible}
                                                  onSave={(values) => saveConfig(values)} saving={saving}/>}
                </div>
            )}
        </div>
    );
}
export default Config;
